import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontSize } = typographyStyles;

export const buttonsStyle = (isActive) => {
  return {
    border: "none",
    borderRadius: "4px",
    padding: "0.4em",
    ...fontSize.textM,
    backgroundColor: isActive ? ui.neutral[100] : "transparent",

    ":not([disabled])&:hover": {
      backgroundColor: isActive ? ui.neutral[300] : ui.neutral[50],
    },

    "&[disabled]": {
      opacity: "0.4",
    },
  };
};
